
import makerjs from "makerjs";
function B52(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,R = Param[1].param,T = Param[2].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       r = R * 1 * myZoom,       
       t = T * 1 * myZoom,       
      
       //hd=r-l,
      //  hd=Math.sqrt(s1*s1-(b/2*b/2)), hh=h-s1+hd,
      //  x0 = 0, x1 = 0, x2 = b, x3 = b, y0 = 0, y1 = hh, y2 = hh, y3 = 0,
       /**假设长半轴为ry 短半轴为 rx 焦点离顶点距离为t
        * rx=r,  c=ry-t a=ry  b=rx=r  c*c=a*a-b*b
        * 求 ry=a=(t*t-r*r)/2*t  
       * */
      aa=r*r/(2*t),
      rx=r,ry=Number(t/2)+Number(aa),
      h = 2*ry,
      w = 2*rx,
       glassH =h, glassW = w;
       if (b !== 0) {
        var TxtB ="B="+ B;
    }  if (R !== 0) {
     var TxtR = "R="+R;
   }    if (t !== 0) {
    var TxtT = "T="+T;
  }
  console.log("rx,ry,h,w,aa=====",rx,ry,h,w,aa);
  // var myEgGapAEllipse=new makerjs.models.Ellipse(rx, ry);
  var drawAbnormalShapeB52=new makerjs.models.Ellipse(rx, ry);
  //  var drawAbnormalShapeB52 = {
  //      paths: {
        
  //       "EllipseArc": makerjs.models.Ellipse(2*t, 2*r),
  //      }
  //  };
   var drawAbnormalShapeB52MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([-b/2, -ry-markShift], [b/2, -ry-markShift]),        
        "RightShortUpline": new makerjs.paths.Line([-b/2, 0-ry], [-b/2, 0-ry-2*markShift]),
        "RightShortDnline": new makerjs.paths.Line([b/2, 0-ry], [b/2, 0-ry-2*markShift]),
       }  
   };
   var drawAbnormalShapeB52MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([-r, 0], [0, 0]),
       }
   };
   var drawAbnormalShapeB52MarkT = {
       paths: {
        "LeftLine": new makerjs.paths.Line([0, ry], [0, ry-t]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeB52MarkB, TxtB,  [-b/2, -ry-2*markShift], [b/2, -ry-2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB52MarkR, TxtR,  [0+markShift, 0], [0+3*markShift, 0]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB52MarkT, TxtT, [0-markShift, ry-t-markShift], [0+2*markShift, ry-t-markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB52: drawAbnormalShapeB52,
      }
    };
  markers={
      models: {
        drawAbnormalShapeB52: drawAbnormalShapeB52,
        drawAbnormalShapeB52MarkB:drawAbnormalShapeB52MarkB,
        drawAbnormalShapeB52MarkR:drawAbnormalShapeB52MarkR,
        drawAbnormalShapeB52MarkT:drawAbnormalShapeB52MarkT,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B52;